/* @flow */

import * as types from './uiCheckInActionTypes';
import { convertBraindateReminderToNotification } from 'src/shared/app/check-in/util/checkInUtil';
import { queueNotification } from 'src/shared/app/notification/action/uiNotificationActions';

import type { Braindate } from '@e180/domain/lib/braindate/type';

export function showCheckInReminder(braindate: Braindate) {
  return queueNotification(convertBraindateReminderToNotification(braindate));
}

export function markCheckInAnimationAsRunning(braindate: Braindate) {
  return {
    type: types.MARK_CHECK_IN_ANIMATION_AS_RUNNING,
    braindate,
  };
}

export function markCheckInAnimationAsDone(braindate: Braindate) {
  return {
    type: types.MARK_CHECK_IN_ANIMATION_AS_DONE,
    braindate,
  };
}

export function markCheckInTakeOverAsOpen(braindate: Braindate) {
  return {
    type: types.MARK_CHECK_IN_TAKE_OVER_AS_OPEN,
    braindate,
  };
}

export function markCheckInTakeOverAsClosed(braindate: Braindate) {
  return {
    type: types.MARK_CHECKIN_TAKE_OVER_AS_CLOSED,
    braindate,
  };
}
